export function restrictedConvertTime(time) {
    var hour = time[0];

    if (hour > 12) {
        return (time[0] - 12) + ":" + String(time[1]*60).padStart(2, '0') + "PM";
    } else {
        return time[0] + ":" + String(time[1]*60).padStart(2, '0') + "AM";
    }
}